
import { debounceTime } from 'rxjs/operators';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { OrganizationService } from '../../shared/services/organization.service';
import { Router, ActivatedRoute, Params, RouterLink } from '@angular/router';
import { Sort, PageEvent } from '@angular/material';
import { StaticValueService } from '../../shared/services/static-value.service';
import { AuthService } from '../../shared/services/auth/auth.service';
import { DeletePopupComponent } from '../Popups/delete-popup/delete-popup.component';
import { MatSnackBar, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs';


@Component({
    selector: 'app-site-list',
    templateUrl: './site-list.component.html',
    styleUrls: ['./site-list.component.css']
})
export class SiteListComponent implements OnInit, OnDestroy {
    @Input() orgId;
    @Input() companyLeaderShip;
    public isLoading: Boolean = false;
    public selectAll = false;
    public numberOfSelectedSites = 0;
    public numberOfAllSelectedSites = 0;
    public bulkOperationSites = {};
    // variables for ACL
    public isHrOrCompanyLeader: Boolean;
    public isAdmin: Boolean;
    public isAssociate: Boolean;
    public currentUserId: string;
    public role: string;
    public siteTypes = [];

    length = 5;
    pageSize = 5;
    pageSizeOptions = [5, 10, 25, 100];
    public organizationId: string;
    public nameSearch: string;
    public sites: any;
    public search: any;
    public query: any;
    public dropDowns: any;
    public searchNameBeh = new BehaviorSubject<string>('');
    public searchNameObs = this.searchNameBeh.asObservable();
    public obserablesArr = [];

    constructor(
        public dialog: MatDialog,
        public organizationService: OrganizationService,
        public route: ActivatedRoute,
        public staticService: StaticValueService,
        public router: Router,
        public authService: AuthService) {
        this.sites = [];
    }

    ngOnDestroy() {
        this.obserablesArr.forEach(element => {
            element.unsubscribe();
        });
    }
    nameSearched() {
        this.searchNameBeh.next(this.search.name);
    }
    ngOnInit() {
        this.obserablesArr.push(this.searchNameObs.pipe(debounceTime(700)).subscribe(value => {
            this.onChange(value);
        }));
        this.organizationId = this.orgId;
        this.currentUserId = this.authService.user.associateId;
        this.dropDowns = this.staticService.staticData.staticDD;
        this.siteTypes = this.dropDowns['site']['physicalType'];
        this.siteTypes = this.siteTypes.concat(this.dropDowns['site']['digitalType']);
        this.organizationId = this.organizationService.organizationId;
        if (this.authService.user.role === 'Admin') {
            this.isHrOrCompanyLeader = false;
            this.isAdmin = true;
            this.isAssociate = false;
        } else if (this.currentUserId === this.organizationService.hrLeaderId ||
            this.authService.user.associateId === this.organizationService.companyLeaderId ||
            (this.companyLeaderShip.hrTeamIds.indexOf(this.currentUserId) > -1)) {
            this.isHrOrCompanyLeader = true;
            this.isAdmin = false;
            this.isAssociate = false;
        } else {
            this.isHrOrCompanyLeader = false;
            this.isAdmin = false;
            this.isAssociate = true;
        }
        this.query = {
            search: {
                'active': true,
                'organizationId': this.organizationId,
                'siteDetails.siteName': { $regex: '', $options: 'i' },
                'siteDetails.cityOfReference': { $regex: '', $options: 'i' }
                // 'team': ''
            },
            sort: {},
            pagination: {
                pageIndex: 0,
                pageSize: this.pageSize
            }
        };
        this.search = {
            name: '',
            type: '',
            city: '',
            archived: false
        };
        this.query.sort = { 'siteDetails.sitePurposeOrderNumber': 1 };
        this.getSites();
    }

    onChange(event) {
        this.selectAll = false;
        this.numberOfAllSelectedSites = 0;
        this.numberOfSelectedSites = 0;
        if (this.isAdmin) {
            if (this.search.archived === false) {
                let tempSearch = {
                    'active': true,
                    'organizationId': this.organizationId,
                    'siteDetails.siteName': { $regex: '', $options: 'i' },
                    'siteDetails.sitePurpose': '',
                    'siteDetails.cityOfReference': { $regex: '', $options: 'i' }
                };
                this.query.search = Object.assign({}, tempSearch);
            } else if (this.search.archived === true) {
                let tempSearch = {
                    'active': false,
                    'organizationId': this.organizationId,
                    'siteDetails.siteName': { $regex: '', $options: 'i' },
                    'siteDetails.sitePurpose': '',
                    'siteDetails.cityOfReference': { $regex: '', $options: 'i' }
                };
                this.query.search = Object.assign({}, tempSearch);
            }
        }
        this.query.search['siteDetails.siteName'] = { $regex: this.search.name, $options: 'i' };
        this.query.search['siteDetails.sitePurpose'] = this.search.type;
        this.query.search['siteDetails.cityOfReference'] = { $regex: this.search.city, $options: 'i' };
        // this.query.search.team = this.search.team;
        this.getSites();
    }

    setPageSizeOptions(setPageSizeOptionsInput: string) {
        this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
    }

    getServerData(event) {
        this.query.pagination.pageIndex = event.pageIndex;
        this.query.pagination.pageSize = event.pageSize;
        this.getSites();
    }

    // open dialog for bulk archive
    openDialog(): void {
        const dialogRef = this.dialog.open(DeletePopupComponent, {
            width: '400px',
            data: { name: 'Sites', length: this.numberOfSelectedSites }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'Cancel') {
            } else if (result === 'Proceed') {
                this.bulkArchive();
            }
        });
    }

    getSites() {
        this.isLoading = true;

        this.organizationService.searchSites(
            this.query.pagination.pageIndex,
            this.query.pagination.pageSize,
            this.query.search,
            this.query.sort
        ).pipe(debounceTime(500))
            .subscribe((data) => {
                this.isLoading = false;
                console.log('Sort Data', data['data']);
                this.sites = data['data'];
                this.numberOfAllSelectedSites = data['numberOfSelectedSites'];
                this.length = this.numberOfAllSelectedSites;
            }, (err) => {
                this.isLoading = false;
            });
    }

    bulkArchive() {
        if (!this.selectAll) {
            this.organizationService.bulkArchiveSites(this.bulkOperationSites).subscribe((data) => {
                this.getSites();
                this.numberOfSelectedSites = 0;
                this.bulkOperationSites = Object.assign({}, {});
            }, (error) => {
            });
        } else {
            this.organizationService.bulkArchiveSites(this.bulkOperationSites, this.query.search).subscribe((data) => {
                this.getSites();
                this.numberOfSelectedSites = 0;
                this.numberOfAllSelectedSites = 0;
                this.bulkOperationSites = Object.assign({}, {});
            }, (error) => {
            });
        }
    }

    sortData(sort: Sort) {
        this.query.sort = {};
        if (sort.direction === 'asc') {
            this.query.sort[sort.active] = -1;
        } else if (sort.direction === 'desc') {
            this.query.sort[sort.active] = 1;
        }
        if (this.query.sort.length === 0) {
            this.query.sort = { 'siteDetails.sitePurposeOrderNumber': 1 };
        }
        this.getSites();
    }

    // multi select functions
    multiSelectChange(event, orgId) {
        if (event.target.checked === true) {
            this.bulkOperationSites[orgId] = orgId;
        } else if (orgId in this.bulkOperationSites) {
            delete this.bulkOperationSites[orgId];
        }
        console.log(this.bulkOperationSites);
        this.selectedsitesNumber();
    }

    // check whether site is in bulkOperations hash
    existsInBulkOperations(orgId) {
        return orgId in this.bulkOperationSites;
    }

    // length of selected Organizations
    selectedsitesNumber() {
        this.numberOfSelectedSites = Object.keys(this.bulkOperationSites).length;
    }

    // select All organizations
    selectAllChange(event) {
        this.selectAll = event.target.checked;
        if (event.target.checked === true) {
            this.numberOfSelectedSites = this.numberOfAllSelectedSites;
        } else if (event.target.checked === false) {
            this.numberOfSelectedSites = 0;
            this.bulkOperationSites = Object.assign({}, {});
        }
    }

}
